// extracted by mini-css-extract-plugin
export var card = "_ky-5";
export var cardSelected = "_ky-4";
export var image = "_ky-3";
export var modal = "_ky-0";
export var modalContent = "_ky-1";
export var table = "_ky-2";